import { atom } from "jotai";
import { type LabelingContextView } from "../Labeling.types";
import { rightDrawerOpenAtom } from "@/features/Navigation/state";

export const baseLabelingContextViewAtom = atom<LabelingContextView | null>(
    null,
);

export const labelingContextViewAtom = atom(
    (get) => get(baseLabelingContextViewAtom),
    (get, set, newValue: LabelingContextView | null) => {
        if (!newValue) {
            set(rightDrawerOpenAtom, false);
            set(baseLabelingContextViewAtom, newValue);
        } else {
            set(baseLabelingContextViewAtom, newValue);
            set(rightDrawerOpenAtom, true);
        }
    },
);
